import { useMemo } from "react";
import CSS from "./static/css/AlertIcon.module.css";
import colorbell_icon_on from "./static/img/mo_icon_bell_dot.png";
import colorbell_icon_off from "./static/img/mo_icon_bell.png";

const AlertIcon = (
    {
        onClick,
        is_active
    }:{
        onClick?: () => void;
        is_active: boolean;
    }
) => {
    const mainClassName = useMemo(() => {
        const RTN: string[] = [CSS.l_AlertIcon_main];

        if(onClick){
            RTN.push("g_click_event_item");
        }

        RTN.push(CSS.l_AlertIcon_main)

        return RTN.join(" ");
    }, [onClick])

    return(
        <div className={mainClassName}>
            <img 
                className={CSS.l_AlertIcon_img}
                src={is_active ? colorbell_icon_on : colorbell_icon_off} 
            />
        </div>
    )
}

export default AlertIcon;